const initialState = {
  menu: null,
  token_bi: null,
  viewSondeo: 1,
  totalPage: 1
}

export default function common(state = initialState, action: any) {
  switch (action.type) {
    case "SET_MENULATERAL":
      const { menu } = action
      return {
        ...state,
        menu,
      }
    case "token_power":
      const { payload } = action
      return {
        ...state,
        token_bi: payload,
      }
    case 'SET_VIEWSONDEO':
      const { data } = action;
      return {
        ...state,
        viewSondeo: data
      }
    case 'SET_TOTALPAGES':
      const { totalPage } = action;
      return {
        ...state,
        totalPage: totalPage
      }

    default:
      return state
  }
}
